export const RESOLVED_STATUS_OPTIONS = [
  {
    value: null,
    text: '-- Lọc theo trạng thái --',
  },
  {
    value: 1,
    text: 'Đã đồng bộ',
  },
  {
    value: 2,
    text: 'Thất bại',
  },
];

export const EXCEPTION_FROM_OPTIONS = [
  {
    value: null,
    text: '-- Lọc theo nguồn lỗi --',
  },
  {
    value: 1,
    text: 'Core',
  },
  {
    value: 2,
    text: 'Fast',
  },
];

// Đồng bộ với BE SYNC_MODULE_NAME (sync-module.js) — đủ toàn bộ module để lọc.
export const MODULE_OPTIONS = [
  { value: null, text: '-- Lọc theo module --' },
  { value: 'productNew', text: 'Tạo mới sản phẩm - Danh mục hàng hóa, vật tư (FAST)' },
  { value: 'productUpdate', text: 'Cập nhật sản phẩm - Danh mục hàng hóa, vật tư (FAST)' },
  { value: 'productDelete', text: 'Xóa sản phẩm - Danh mục hàng hóa, vật tư (FAST)' },
  { value: 'productMigrate', text: 'Đồng bộ lại Danh mục hàng hóa, vật tư (FAST)' },
  { value: 'categoryNew', text: 'Tạo mới danh mục sản phẩm - Danh mục nhóm hàng hóa, vật tư (FAST)' },
  { value: 'categoryUpdate', text: 'Cập nhật danh mục sản phẩm - Danh mục nhóm hàng hóa, vật tư (FAST)' },
  { value: 'categoryMerge', text: 'Gộp danh mục sản phẩm - Danh mục nhóm hàng hóa, vật tư (FAST)' },
  { value: 'categoryDelete', text: 'Xóa danh mục sản phẩm - Danh mục nhóm hàng hóa, vật tư (FAST)' },
  { value: 'categoryMove', text: 'Di chuyển danh mục sản phẩm - Danh mục nhóm hàng hóa, vật tư (FAST)' },
  { value: 'categoryMigrate', text: 'Đồng bộ lại danh mục hàng nhóm hàng hóa vật tư (FAST)' },
  { value: 'providerNew', text: 'Tạo mới nhà cung cấp - Danh mục nhà cung cấp (FAST)' },
  { value: 'providerUpdate', text: 'Cập nhật nhà cung cấp - Danh mục nhà cung cấp (FAST)' },
  { value: 'providerDelete', text: 'Xóa nhà cung cấp - Danh mục nhà cung cấp (FAST)' },
  { value: 'providerMigrate', text: 'Đồng bộ lại Danh mục nhà cung cấp (FAST)' },
  { value: 'businessNew', text: 'Tạo mới khách hàng doanh nghiệp - Danh mục khách hàng (FAST)' },
  { value: 'businessUpdate', text: 'Cập nhật khách hàng doanh nghiệp - Danh mục khách hàng (FAST)' },
  { value: 'businessDelete', text: 'Xóa khách hàng doanh nghiệp - Danh mục khách hàng (FAST)' },
  { value: 'businessMigrate', text: 'Đồng bộ lại khách hàng doanh nghiệp' },
  { value: 'storeNew', text: 'Tạo mới cửa hàng - Danh mục kho (FAST)' },
  { value: 'storeUpdate', text: 'Cập nhật cửa hàng - Danh mục kho (FAST)' },
  { value: 'storeDelete', text: 'Xóa cửa hàng - Danh mục kho (FAST)' },
  { value: 'storeMigrate', text: 'Đồng bộ lại Danh mục kho (FAST)' },
  { value: 'billNew', text: 'Tạo mới hóa đơn - Hóa đơn bán hàng (FAST)' },
  { value: 'billUpdate', text: 'Cập nhật hóa đơn - Hóa đơn bán hàng (FAST)' },
  { value: 'billDelete', text: 'Xóa hóa đơn - Hóa đơn bán hàng (FAST)' },
  { value: 'billMigrate', text: 'Đồng bộ hóa đơn - Hóa đơn bán hàng (FAST)' },
  { value: 'billVatExport', text: 'Xuất hóa đơn VAT - Hóa đơn bản thuế (FAST)' },
  { value: 'billVatExportMigrate', text: 'Đồng bộ lại Hóa đơn bản thuế (FAST)' },
  { value: 'transactionCashInNew', text: 'Tạo mới phiếu thu tiền mặt' },
  { value: 'transactionBankInNew', text: 'Tạo mới giấy báo có (phiếu thu ngân hàng)' },
  { value: 'transactionCashOutNew', text: 'Tạo mới phiếu chi tiền mặt' },
  { value: 'transactionBankOutNew', text: 'Tạo mới giấy báo nợ (phiếu chi ngân hàng)' },
  { value: 'transactionCashInUpdate', text: 'Cập nhật phiếu thu tiền mặt' },
  { value: 'transactionBankInUpdate', text: 'Cập nhật giấy báo có (phiếu thu ngân hàng)' },
  { value: 'transactionCashOutUpdate', text: 'Cập nhật phiếu chi tiền mặt' },
  { value: 'transactionBankOutUpdate', text: 'Cập nhật giấy báo nợ (phiếu chi ngân hàng)' },
  { value: 'transactionCashInDelete', text: 'Xóa phiếu thu tiền mặt' },
  { value: 'transactionBankInDelete', text: 'Xóa giấy báo có (phiếu thu ngân hàng)' },
  { value: 'transactionCashOutDelete', text: 'Xóa phiếu chi tiền mặt' },
  { value: 'transactionBankOutDelete', text: 'Xóa giấy báo nợ (phiếu chi ngân hàng)' },
  { value: 'creditNew', text: 'Tạo mới thanh toán quẹt thẻ - Phiếu kế toán tổng hợp (FAST)' },
  { value: 'installmentNew', text: 'Tạo mới thanh toán trả góp - Phiếu kế toán tổng hợp (FAST)' },
  { value: 'creditUpdate', text: 'Cập nhật thanh toán quẹt thẻ - Phiếu kế toán tổng hợp (FAST)' },
  { value: 'installmentUpdate', text: 'Cập nhật thanh toán trả góp - Phiếu kế toán tổng hợp (FAST)' },
  { value: 'importStockSlipNew', text: 'Tạo mới phiếu nhập kho NCC - Hóa đơn mua hàng trong nước (FAST)' },
  { value: 'importStockSlipUpdate', text: 'Cập nhật phiếu nhập kho NCC - Hóa đơn mua hàng trong nước (FAST)' },
  { value: 'importStockSlipDelete', text: 'Xoá phiếu nhập kho NCC - Hóa đơn mua hàng trong nước (FAST)' },
  { value: 'importStockTransferNew', text: 'Tạo mới phiều chuyển kho' },
  { value: 'importStockTransferUpdate', text: 'Cập nhật phiếu chuyển kho' },
  { value: 'importStockTransferDelete', text: 'Xóa phiếu chuyển kho' },
  { value: 'importExportWarrantyStockSlipNew', text: 'Tạo mới phiếu nhập kho bảo hành - Phiếu nhập kho (FAST)' },
  { value: 'importExportWarrantyStockSlipUpdate', text: 'Cập nhật phiếu nhập kho bảo hành - Phiếu nhập kho (FAST)' },
  { value: 'importExportWarrantyStockSlipDelete', text: 'Xóa phiếu nhập kho bảo hành - Phiếu nhập kho (FAST)' },
  { value: 'importConsignmentStockSlipNew', text: 'Tạo mới phiếu nhập kho ký gửi - Phiếu nhập kho (FAST)' },
  { value: 'importConsignmentStockSlipUpdate', text: 'Cập nhật phiếu nhập kho ký gửi - Phiếu nhập kho (FAST)' },
  { value: 'importStockSlipByChangingImeiNew', text: 'Tạo mới phiếu nhập kho nghiệp vụ đổi imei sản phẩm - Phiếu nhập kho (FAST)' },
  { value: 'importStockSlipByChangingImeiUpdate', text: 'Cập nhật phiếu nhập kho nghiệp vụ đổi imei sản phẩm - Phiếu nhập kho (FAST)' },
  { value: 'refundBillNew', text: 'Tạo mới phiếu trả hàng - Phiếu nhập hàng bán trả lại  (FAST)' },
  { value: 'refundBillUpdate', text: 'Cập nhật phiếu trả hàng - Phiếu nhập hàng bán trả lại (FAST)' },
  { value: 'refundBillDelete', text: 'Xóa phiếu trả hàng - Phiếu nhập hàng bán trả lại (FAST)' },
  { value: 'confirmStockTransfer', text: 'Xác nhận phiếu XNK - Phiếu xuất điều chuyển (FAST)' },
  { value: 'confirmWarrantyStockTransfer', text: 'Xác nhận phiếu chuyển kho bảo hành' },
  { value: 'exportStockSlip', text: 'Xuất kho trả NCC - Phiếu xuất trả lại nhà cung cấp (FAST)' },
  { value: 'exportStockSlipNew', text: 'Tạo mới phiếu xuất kho trả NCC - Phiếu xuất trả lại nhà cung cấp (FAST)' },
  { value: 'exportStockSlipUpdate', text: 'Cập nhật phiếu xuất kho trả NCC - Phiếu xuất trả lại nhà cung cấp (FAST)' },
  { value: 'exportStockSlipDelete', text: 'Xoá phiếu xuất kho trả NCC - Phiếu xuất trả lại nhà cung cấp (FAST)' },
  { value: 'exportRemainStockSlipNew', text: 'Tạo mới phiếu xuất kho - Phiếu xuất kho (FAST)' },
  { value: 'exportRemainStockSlipUpdate', text: 'Cập nhật phiếu xuất kho - Phiếu xuất kho (FAST)' },
  { value: 'exportRemainStockSlipDelete', text: 'Xoá phiếu xuất kho - Phiếu xuất kho (FAST)' },
  { value: 'createGeneralVouchersNew', text: 'Tạo mới Trả hàng có phí trả hàng - Phiếu kế toán tổng hợp (FAST)' },
  { value: 'createGeneralVouchersUpdate', text: 'Cập nhật Trả hàng có phí trả hàng - Phiếu kế toán tổng hợp (FAST)' },
  { value: 'createGeneralVouchersDelete', text: 'Xóa Trả hàng có phí trả hàng - Phiếu kế toán tổng hợp (FAST)' },
  { value: 'issueRequiredStockToPortal', text: 'Xuất kho điều chuyển theo yêu cầu - Portal Fast' },
];

export const TABLE_FIELDS = [
  {
    key: 'selected',
    label: '',
    thStyle: { textAlign: 'center', width: '1%' },
    tdClass: 'text-center align-middle',
  },
  {
    key: 'referenceId',
    label: 'Id tham chiếu',
    thStyle: { textAlign: 'center', width: '3%' },
    tdClass: 'text-center align-middle',
  },
  {
    key: 'moduleName',
    label: 'Tên module',
    thStyle: { textAlign: 'center', width: '4%' },
    tdClass: 'text-left align-middle',
  },
  {
    key: 'id',
    label: 'Chi tiết',
    thStyle: { textAlign: 'center', width: '2%' },
    tdClass: 'text-center align-middle',
  },
  {
    key: 'isResolved',
    label: 'Trạng thái',
    thStyle: { textAlign: 'center', width: '2%' },
    tdClass: 'text-center align-middle',
  },
  {
    key: 'action',
    label: 'Hành động',
    thStyle: { width: '1%', textAlign: 'center' },
    tdClass: 'text-center align-middle',
  },
];
